import { motion } from "framer-motion";
import { MANIFESTO } from "@/data/content";

export default function Manifesto() {
  return (
    <section className="relative border-y border-white/10 bg-[#0a0c12] py-16 sm:py-24 lg:py-32" data-testid="manifesto-section">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <div className="inline-flex items-center gap-3">
                <span className="h-px w-8 bg-[#e01e37]" />
                <span className="font-mono text-[11px] uppercase tracking-[0.25em] text-[#e01e37]">
                  Manifest
                </span>
              </div>
              <h2 className="mt-6 font-display text-3xl lg:text-5xl font-extrabold tracking-tight text-white leading-[1.05]">
                Warum CashFUX anders gebaut ist.
              </h2>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="border-t border-white/10">
              {MANIFESTO.map((m, i) => (
                <motion.div
                  key={m.no}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.7, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                  className="group grid grid-cols-1 sm:grid-cols-12 gap-4 sm:gap-8 border-b border-white/10 py-10"
                  data-testid={`manifesto-item-${m.no}`}
                >
                  <div className="sm:col-span-2">
                    <span className="font-mono text-3xl text-white/20 transition-colors duration-500 group-hover:text-[#e01e37]">
                      {m.no}
                    </span>
                  </div>
                  <div className="sm:col-span-10">
                    <h3 className="font-display text-2xl lg:text-3xl font-bold tracking-tight text-white">
                      {m.title}
                    </h3>
                    <p className="mt-4 max-w-2xl text-base leading-relaxed text-white/55">
                      {m.desc}
                    </p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
